export const PRIDE_STRIPES_COUNT = 6;

const PRIDE_STRIPES: readonly (readonly [number, number, number])[] = [
  [353, 82, 55],
  [28, 100, 52],
  [48, 100, 52],
  [140, 70, 42],
  [216, 90, 52],
  [286, 62, 48],
];

export function prideStripeColor(index: number, alpha: number): string {
  const [hue, saturation, lightness] =
    PRIDE_STRIPES[((index % PRIDE_STRIPES_COUNT) + PRIDE_STRIPES_COUNT) % PRIDE_STRIPES_COUNT];
  return `hsla(${hue}, ${saturation}%, ${lightness}%, ${alpha})`;
}
